module.exports = __webpack_public_path__ + "img/0210_japanese-paper_00085.60775fa7.jpg";